import { motion } from "framer-motion";
import { Plane } from "lucide-react";

const links = [
  { label: "Experience", href: "#experience" },
  { label: "Projects", href: "#projects" },
  { label: "Instant Pitch", href: "#pitch" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 1.6, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/5 border-b border-white/10"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo">
          <span className="w-8 h-8 rounded-full bg-[#FF1493] flex items-center justify-center transition-transform duration-500 group-hover:rotate-45">
            <Plane size={15} strokeWidth={1.5} className="text-black" />
          </span>
          <span className="font-tech text-xs tracking-[0.3em] uppercase text-white/80">
            TANVI
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="nav-link font-tech text-[11px] tracking-[0.25em] uppercase text-white/60"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          data-testid="nav-cta-button"
          className="hidden md:inline-flex items-center gap-2 rounded-full border border-[#FF1493]/60 px-5 py-2 font-tech text-[11px] tracking-[0.2em] uppercase text-[#FF66B2] transition-colors duration-300 hover:bg-[#FF1493] hover:text-black"
        >
          Board Me
        </a>
      </div>
    </motion.header>
  );
};
